import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IndicadorArquivoService } from '../indicador-arquivo.service';
import { downloadUrl } from '../../util/utils';

@Component({
  selector: 'app-indicador-arquivo-baixar',
  templateUrl: './indicador-arquivo-baixar.component.html',
  styleUrls: ['./indicador-arquivo-baixar.component.css'],
})
export class IndicadorArquivoBaixarComponent implements OnInit {
  endereco: string;
  url: string;
  carregando = false;
  erro: string;

  constructor(private service: IndicadorArquivoService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.endereco = params.get('endereco');
      if (this.endereco) {
        this.carregando = true;
        this.service
          .recuperarConteudoUrlPorEndereco(this.endereco)
          .then((url) => {
            this.url = url;
            this.carregando = false;

            let nome;

            try {
              nome = this.endereco.substring(this.endereco.lastIndexOf('/'));
            } catch {
              nome = 'arquivo.zip';
            }

            setTimeout(() => downloadUrl(nome, url), 300);
          })
          .catch((response) => {
            this.carregando = false;
            this.erro = `Erro ao baixar o arquivo do indicador: ${this.endereco}`;
            if (response.error !== null) {
              this.erro += ' - ' + response.error;
            }
          });
      }
    });
  }
}
